import { Capacitor } from '@capacitor/core';
import {
  clearStoredMobileAccessToken,
  getStoredMobileAccessToken,
  saveStoredMobileAccessToken,
} from './mobileTokenStorage';

export const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const getMobileAccessToken = async () => {
  if (!isNativeApp()) {
    return null;
  }
  return getStoredMobileAccessToken();
};

export const saveMobileAccessToken = async (token) => {
  if (!isNativeApp()) {
    return;
  }
  await saveStoredMobileAccessToken(token);
};

export const saveMobileAuthPayload = async (payload) => {
  if (payload?.access_token) {
    await saveMobileAccessToken(payload.access_token);
  }
};

export const hasMobileAuthPayload = async () => Boolean(await getMobileAccessToken());

export const clearMobileAuth = async () => {
  if (!isNativeApp()) {
    return;
  }
  await clearStoredMobileAccessToken();
};
